// extracted by mini-css-extract-plugin
export default {"textWrapper":"Mintscan_textWrapper__9FGUw","img":"Mintscan_img__8I0fI"};